/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigniusRegisterRequestDto
 */
export interface SigniusRegisterRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SigniusRegisterRequestDto
     */
    email: string;
    /**
     * International format, e.g. +49123456789
     * @type {string}
     * @memberof SigniusRegisterRequestDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof SigniusRegisterRequestDto
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof SigniusRegisterRequestDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof SigniusRegisterRequestDto
     */
    lastName: string;
    /**
     * Two-letter uppercase country code, e.g. DE
     * @type {string}
     * @memberof SigniusRegisterRequestDto
     */
    citizenship: string;
    /**
     * Language for the Signius account, e.g. en or de
     * @type {string}
     * @memberof SigniusRegisterRequestDto
     */
    language?: string;
}

/**
 * Check if a given object implements the SigniusRegisterRequestDto interface.
 */
export function instanceOfSigniusRegisterRequestDto(value: object): value is SigniusRegisterRequestDto {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('citizenship' in value) || value['citizenship'] === undefined) return false;
    return true;
}

export function SigniusRegisterRequestDtoFromJSON(json: any): SigniusRegisterRequestDto {
    return SigniusRegisterRequestDtoFromJSONTyped(json, false);
}

export function SigniusRegisterRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigniusRegisterRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'phoneNumber': json['phoneNumber'],
        'password': json['password'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'citizenship': json['citizenship'],
        'language': json['language'] == null ? undefined : json['language'],
    };
}

export function SigniusRegisterRequestDtoToJSON(json: any): SigniusRegisterRequestDto {
    return SigniusRegisterRequestDtoToJSONTyped(json, false);
}

export function SigniusRegisterRequestDtoToJSONTyped(value?: SigniusRegisterRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'password': value['password'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'citizenship': value['citizenship'],
        'language': value['language'],
    };
}

